// extracted by mini-css-extract-plugin
export default {"contact-card":"Card_contact-card__3pF3v","item":"Card_item__ylDY9","icon-box":"Card_icon-box__uCWFw","content":"Card_content__+8yPz"};